import type { SettlementStatus } from './types';

export interface SettlementStatusMeta {
  label: string;
  bg: string;
  text: string;
  darkBg: string;
  darkText: string;
}

const STATUS_META: Record<SettlementStatus, SettlementStatusMeta> = {
  PENDING: {
    label: 'Pending',
    bg: 'bg-amber-100', text: 'text-amber-700',
    darkBg: 'dark:bg-amber-900/30', darkText: 'dark:text-amber-300',
  },
  PAID: {
    label: 'Paid',
    bg: 'bg-success-100', text: 'text-success-700',
    darkBg: 'dark:bg-success-900/30', darkText: 'dark:text-success-300',
  },
  CANCELLED: {
    label: 'Cancelled',
    bg: 'bg-neutral-100', text: 'text-neutral-600',
    darkBg: 'dark:bg-neutral-800', darkText: 'dark:text-neutral-400',
  },
};

export function settlementStatusMeta(status: SettlementStatus): SettlementStatusMeta {
  return STATUS_META[status] ?? STATUS_META.PENDING;
}
